import { Component } from '@angular/core';

@Component({
  selector: 'app-purchase-cost-variation-log',
  standalone: false,
  
  templateUrl: './purchase-cost-variation-log.component.html',
  styles: ``
})
export class PurchaseCostVariationLogComponent {

}
